var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJivoMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 49,
    viewBox: "0 0 49 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_453_2129)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5 49C38.031 49 49 38.031 49 24.5C49 10.969 38.031 0 24.5 0C10.969 0 0 10.969 0 24.5C0 38.031 10.969 49 24.5 49Z",
    fill: "#7DA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.537 10.236C15.273 10.236 7.76398 16.14 7.76398 23.419C7.76398 26.865 9.44798 30.008 12.206 32.356C12.101 34.646 11.626 37.723 9.94898 39.31C13.153 39.31 16.433 37.2 18.379 35.68C20.286 36.275 22.363 36.601 24.537 36.601C33.8 36.601 41.31 30.698 41.31 23.419C41.31 16.139 33.8 10.236 24.537 10.236Z",
    fill: "#0F172A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9998 16.0979L24.0962 25.024L19.8507 21.5468L15.9998 24.4645V29.6226L19.7514 26.7801L24.3755 30.5675L32.9998 21.9214V16.0979Z",
    fill: "#7DA2FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0803 16.0353L33.0677 16.0298L33.0712 16.0263L33.0803 16.0353Z",
    fill: "#7DA2FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_453_2129"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 49,
    height: 49,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJivoMobile);
export default __webpack_public_path__ + "static/media/jivo_mobile.4066e83f09c864446a93106b5b537753.svg";
export { ForwardRef as ReactComponent };